import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { ConfigService } from "./config.service";

@Injectable({ providedIn: 'root' })
export class Configuracoes {
	constructor (
		private httpClient: HttpClient,
		private configService: ConfigService
	) {}

	public getConfigNumber(): Observable<string> {		
		return this.httpClient.get<string>(this.configService.getEndereco() + "/cotacao/getConfiguracaoSistema",
		{
			headers: this.configService.getHeaders()
		});
	}
}